import { fromTemplate } from '../../utils/dom.js';
import './services.css';

const ITEMS = [
  {
    id: 'web',
    title: 'Websites',
    body: 'Marketing sites, product sites, and SPAs built with modern, framework-light JavaScript and a focus on speed and accessibility.'
  },
  {
    id: 'ios',
    title: 'iOS & iPadOS & macOS',
    body: 'Native apps written in Swift and SwiftUI that feel at home on iPhone, iPad, and macOS.'
  },
  {
    id: 'macos',
    title: 'Enterprise & Cloud',
    body: 'Enterprise solutions that scale including Apps, APIs, and cloud services deployed on Azure. '
  }
];

export class Services {
  render() {
    const cards = ITEMS.map((i) => `
      <li class="sl-services__card" data-testid="service-card-${i.id}">
        <h3 class="sl-services__card-title">${i.title}</h3>
        <p class="sl-services__card-body">${i.body}</p>
      </li>
    `).join('');

    const template = `
      <section class="sl-services" id="services" data-testid="services">
        <div class="container">
          <header class="sl-services__head">
            <h2 class="sl-services__title">What we build</h2>
            <p class="sl-services__subtitle">A small studio with a focused
              practice across the web and the Apple ecosystem.</p>
          </header>
          <ul class="sl-services__grid">${cards}</ul>
        </div>
      </section>
    `;
    return fromTemplate(template);
  }
}
